export default __webpack_public_path__ + "static/media/contributions_icon.7fdece2e.svg";